export default {
  init: function () {
    return this.xf['@@transducer/init']();
  },
  result: function (result) {
    return this.xf['@@transducer/result'](result);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_xfBase.js
// module id = 31
// module chunks = 1